<template>
  <div class="hpsfir-card feedback">
    <HpsfirProTable
      ref="tableRef"
      title="投诉反馈"
      :paginations="{ pageSize: 10 }"
      page-layout="total, sizes, prev, pager, next"
      :columns="columns"
      :get-data="getData"
      :on-delete="deleteFun"
      :loading="loading"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="tsx" setup>
import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElImage } from 'element-plus';
import { ref } from 'vue';

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();

const addInitValue = {

};

const conditionsInitValue = {
};


// 创建列定义
const createColumns = () => [
  {
    name: 'reason',
    label: '投诉反馈原因',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入投诉反馈原因' }],
    width: 300,
  },
  {
    name: 'imageUrls',
    label: '图片列表',
    type: 'textarea',
    width: 200,
    render: ({ row }: { row: any }) => (
      <div>
        {row.imageUrls.map((url: string) => (
          <ElImage src={url} alt="image" style="width: 100px; height: 100px;" preview-src-list={row.imageUrls} preview-teleported={true}/>
        ))}
        {row.imageUrls.length === 0 && '暂无图片'}
      </div>
    ),
  },
  {
    name: 'createTime',
    label: '反馈时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 120,
  },
] as HpsfirProTableColumn[];


// 初始化
const init = useBaseAsync(() => {
  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().feedbackApi.pageAllFeedbackfeedback({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.reason || '未命名反馈'}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().feedbackApi.createFeedbackfeedback({
    feedbackAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().feedbackApi.adminUpdateFeedbackfeedback({
    feedbackAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().feedbackApi.adminDelFeedbackfeedback(data.id);
  ElMessage.success('删除成功');
});


Promise.all([init()]);
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
